// Display-only colour/label maps for the Registration & Regulatory
// Compliance module - mirrors pages/cqcCentre/severity.js's convention.
// These are NOT the assessment logic (that lives server-side, see
// helpers/registration/exemptionAssessment.js) - purely how outcomes/statuses
// are rendered.
export const EXPOSURE_OUTCOME = {
  likely_exempt: { label: 'Likely Exempt', color: 'success' },
  likely_requires_registration: { label: 'Likely Requires Registration', color: 'error' },
  uncertain: { label: 'Uncertain', color: 'warning' },
  not_assessed: { label: 'Not Assessed', color: 'default' },
}

export const REGISTRATION_STATUS = {
  not_registered: { label: 'Not Registered', color: 'error' },
  preparing_application: { label: 'Preparing Application', color: 'warning' },
  applied: { label: 'Applied', color: 'info' },
  registered: { label: 'Registered', color: 'success' },
  exempt: { label: 'Exempt', color: 'default' },
  not_applicable: { label: 'Not Applicable', color: 'default' },
}
